<template>
  <Modal v-model="visible"  :loading="modalLoading"  closable mask-closable
     :okText="getTranslation('m091')" :cancelText="getTranslation('b182')" :title="getTranslation('m091')"
    width="45">
    <fieldset class="my-fieldset first-fieldset">
      <legend class="my-legend">{{ getTranslation('m152') }}</legend>
      <div>
          <CheckboxGroup v-model="selectedParams">
    <Row class="field-line menu-actions" type="flex">
      <Col flex="1" class="desc-field flex-left">
      <Checkbox  label="backprog">{{ getTranslation('m092') }}</Checkbox>
      </Col>
      <Col flex="1">
      <Checkbox  label="backsys">{{ getTranslation('m093') }}</Checkbox>
      </Col>
      <Col flex="1">
      <Checkbox  label="backspot">{{ getTranslation('k246') }}</Checkbox>
      </Col>
      <Col flex="1" class="flex-right">
        <Button  type="warning" icon="md-swap"  @click="startBackup()">{{ getTranslation('m091') }}</Button>
      </Col>
    </Row> 
    </CheckboxGroup>
      </div>
    </fieldset>
    <fieldset class="my-fieldset normal-fieldset">
      <legend class="my-legend">{{ getTranslation('m201') }}</legend>      
      <Row class="field-line menu-actions" type="flex">
      <Col flex="5" class="desc-field" >
      <Select  :transfer="true" class="input-field" :filterable="true" v-model="selectedBackup" 
        :placeholder="getTranslation('m034')" 
        :not-found-text="getTranslation('b038')">
        <Option v-for="item in backupList" :value="item" :key="item.id">{{ item }}</Option>
      </Select>
      </Col>
      <Col flex="1" class="flex-right">
      <Button  type="primary" icon="md-download" @click.native="downloadBackup()">{{getTranslation('k023')}}</Button>
      </Col>
    </Row>
    
      </fieldset>
    
     <div slot="footer">
        <Row type="flex">
          <Col flex="1" class="flex-middle">
            <Button  type="default" icon="md-close" @click="cancel">{{ getTranslation('b182') }}</Button>
          </Col>
        </Row>
      </div>   
  </Modal>

</template>
<script>

import { API_URL } from '@/constants/const.js'
import axios from 'axios';
import { Modal, Row, Col, Select, Option, CheckboxGroup,Checkbox,Button } from 'view-design';
import { mapGetters } from 'vuex'
import { postJsError,exportFile,blobToString } from '@/util/util.js'

export default {
  name: 'MachineBackup', // 组件名称
  components: {
    Modal, Row, Col,  Select, Option, CheckboxGroup,Checkbox,Button,
  },
  props: {
    propVisible: Boolean,
    selectedItems: Array,
  },
  data() {
    return {
      modalLoading: true,
      backupList:[],
      selectedParams:["backprog","backsys","backspot"],
      selectedBackup:null,
      timeRange:"1 MONTH",
    }
  },
  computed: {
    ...mapGetters(['getTranslation']),
    visible: {
      get() { return this.propVisible },
      set(val) { this.$emit('input', val) }
    },   
  },
  watch: {
    visible(newVal) {
      if (newVal) {        
        this.getBackupList();
      }
    }
  },

  created() {
    
  },
  methods: {
    getBackupList() {
      let url = API_URL["machineGetBackupList"];
      let params = {       
      }
      axios.get(url, {
        params: params,        
      })
        .then(res => {
          if (res && res.data && res.data.code == 200) {
            this.backupList = res.data.data;
            if(this.backupList && this.backupList.length>0){
              this.selectedBackup = this.backupList[0];
            }else {
              this.selectedBackup = null;
            }
          } else if (res && res.data && res.data.msg) {
            this.$Message.error(res.data.msg);
          } else {
            this.$Message.error(this.getTranslation('c001'));
          }
        })
        .catch((err) => {
          postJsError(err)
          this.$Message.error(this.getTranslation('c001'));
        })
    },
    startBackup() {
      let _this = this;
      this.modalLoading = true; 
      if(this.selectedItems.length==0 ){
        this.$Message.error(this.getTranslation('m094'));
        this.modalLoading = false;
        this.resetModal();
        return ;
      }      
      if(this.selectedParams.length==0 ){
        this.$Message.error(this.getTranslation('m095'));
        this.modalLoading = false;
        this.resetModal();
        return ;
      }     
      let url = API_URL["machineBackup"];
       let formData = new FormData();
       formData.append('ids', this.selectedItems.join(','));
       formData.append('backupParams', this.selectedParams.join(','));
       axios.post(url,
            formData
            ,{timeout: 300000}
        )
      .then(res => {
        if (res && res.data && res.data.code && res.data.code == 200) {            
          this.$Message.success(res.data.msg);            
          this.visible = false
          this.softPassword = "";
          _this.$emit("backup-start",this.selectedParams.join(','))
        } else if (res && res.data && res.data.code && res.data.msg) {
          this.$Message.error(res.data.msg);
          this.modalLoading = false;
          this.resetModal();
        } else {
          this.modalLoading = false;
          this.resetModal();
        }
      })
      .catch((err) => {
        postJsError(err)
        this.modalLoading = false;
        this.resetModal();
        this.$Message.error(this.getTranslation('c001'));
      })
    },
   
    resetModal() {
      this.$nextTick(() => {
        this.modalLoading = true;
      });
    },
    cancel() {
      this.visible = false
    },
    async downloadBackup(){      
      this.modalLoading = true;  
      let url = API_URL["machineDownloadBackup"];     
      let params = {
        lot:this.selectedBackup
      };
      const response = await axios.get(url, {
        params: params,
        responseType: 'blob',
      });
      if (response.status == 200) {        
        const contentType = response.headers['content-type'];
        if (contentType && contentType.includes('application/json')) {
          blobToString(response.data).then(text => {
            let msgData = JSON.parse(text);
            if (msgData.msg) {
              this.$Message.error(msgData.msg)
              this.modalLoading = false;
          this.resetModal();
            }
          }).catch((err) => {
            this.modalLoading = false;
          this.resetModal();
            postJsError(err)        
            this.$Message.error(this.getTranslation('c001'));
          });
        } else {
            exportFile(response)
            this.visible = false 
        }
      } else {
        this.$Message.error(this.getTranslation('c001'));
        this.modalLoading = false;
        this.resetModal();
      }     
    },
    clearBackup(){
       this.$Modal.confirm({
        title: "",
        content: this.getTranslation('m205'),
        okText: this.getTranslation('b181'),
        cancelText: this.getTranslation('b182'),
        onOk: () => {
          let url = API_URL["machineClearBackup"];
          let params = {            
            timeRange: this.timeRange,
          }
          axios.get(url, {
            params: params
          })
            .then(res => {
              if (res && res.data && res.data.code == 200) {
                this.$Message.success(res.data.msg);
                this.getBackupList();
              } else if (res && res.data && res.data.msg) {
                this.$Message.error(res.data.msg);
              } else {
                this.$Message.error(this.getTranslation('c001'));
              }
            })
            .catch((err) => {
              postJsError(err)
              this.$Message.error(this.getTranslation('c001'));
            })
        }
      });
    }  
  },

}
</script>

<style scoped>
  @import url("../../../assets/style/tab.css");
.desc-field {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding-right: 3%;
  font-size: 0.9rem;
}

.field-line {
  margin-bottom: 8px;
}

.slave-tips {
  display: flex;
  align-items: center;
  padding-left: 1%;
  font-size: 0.9rem;
}

.auto-start {
  font-size: 0.9rem;
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
.first-fieldset{
  margin-top: -10px; 
}
</style>